import { getOptions } from "@/shared/api/options"
import { createAsyncThunk } from "@reduxjs/toolkit"

export const fetchOptions = createAsyncThunk("options/fetchOptions", async () => {
    return getOptions()
})
